import { apiClient } from '@/lib/api.ts'

export function getGlobalAdapters() {
  return apiClient.get('/global/adapters')
}

export function saveGlobalAdapter(data: {
  adapter: string
  label: string | null
  config: Record<string, unknown>
  isActive: boolean
}) {
  return apiClient.put('/global/adapters', data)
}

export function deleteGlobalAdapter(adapter: string) {
  return apiClient.delete(`/global/adapters/${adapter}`)
}
